export class PageEntryItem {
  readonly startPage: number;
  readonly endPage: number;
  readonly entityId?: number;
  readonly userRank?: number;

  constructor(options: {
    startPage: number;
    endPage: number;
    entityId?: number;
    userRank?: number;
  }) {
    this.startPage = options.startPage;
    this.endPage = options.endPage;
    this.entityId = options.entityId;
    this.userRank = options.userRank;
  }
}
